module.exports = __webpack_public_path__ + "img/colorful.56dbd4a3.png";